export default {
    setDisclaimer: (state, disclaimer) => { state.disclaimer = disclaimer },
    setLoadingOff: state => { state.loading = false },
    setLoadingOn: state => { state.loading = true },
    setCalculatorModel: (state, calculatorModel) => { state.calculatorModel = calculatorModel },
    setAlert: (state, alert) => { state.alert = alert },
    setUser: (state, user) => { state.user = user },
    setVeterinaryColleges: (state, veterinaryColleges) => { state.veterinaryColleges = veterinaryColleges },
    setIsDrugsManagement: (state, isDrugsManagement) => { state.isDrugsManagement = isDrugsManagement },
    setUserSection: (state, userSection) => { state.userSection = userSection },
    setLinkRedirect: (state, link_redirect) => { state.link_redirect = link_redirect },
    closeConfirmModel: (state) => { state.confirmModel.active = false },
    setConfirmModel: (state, { alert, active, text, action, confirmText, closeText, parameters, cancelParameters, cancelAction, callback }) => {
        state.confirmModel = { alert, active, text, action, confirmText, closeText, parameters, cancelParameters, cancelAction, callback }
    },
    setHasDynamicLink: (state, hasDynamicLink) => { state.hasDynamicLink = hasDynamicLink },
    setFromLogin: (state, fromLogin) => { state.fromLogin = fromLogin },
    setStepper: (state, stepper) => { state.stepper = stepper },
    setStepperTotal: (state, stepperTotal) => { state.stepperTotal = stepperTotal },
    setStepperData: (state, stepperData) => { state.stepperData = stepperData },
    setStepperModel: (state, stepperModel) => { state.stepperModel = stepperModel },
    setHomeAdds: (state, homeAdds) => { state.homeAdds = homeAdds },
    setEmailConfirmation: (state, emailConfirmation) => { state.emailConfirmation = emailConfirmation },
}